import { formatAppointmentHistoryDate } from "./appointmentShared";

export const AppointmentAuditDetails = ({ appt, variant = "table" }) => {
    if (variant === "mobile") {
        return (
            <>
                <div className="space-y-2">
                    <span className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                        Notas
                    </span>
                    <div className="text-sm text-gray-700 dark:text-gray-200">
                        {appt.notes ? (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: appt.notes,
                                }}
                            />
                        ) : (
                            <span className="text-gray-400 dark:text-gray-500 italic">
                                Sin notas
                            </span>
                        )}
                    </div>
                </div>

                {appt.statusHistory?.length > 0 && (
                    <div className="space-y-2">
                        <span className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                            Cambios de estado
                        </span>
                        <div className="space-y-2">
                            {appt.statusHistory.map((change, index) => (
                                <div
                                    key={`${appt.id || appt.time}-history-${index}`}
                                    className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-gray-900 px-3 py-2 text-sm"
                                >
                                    <div className="flex flex-wrap gap-2 items-center">
                                        {index === 0 && change.oldStatus && (
                                            <span className="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200">
                                                {change.oldStatus}
                                            </span>
                                        )}
                                        <span className="text-gray-400">→</span>
                                        <span className="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                                            {change.newStatus}
                                        </span>
                                    </div>
                                    <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
                                        Por{" "}
                                        <span className="font-semibold text-gray-700 dark:text-gray-200">
                                            {change.changedBy}
                                        </span>{" "}
                                        el{" "}
                                        {formatAppointmentHistoryDate(
                                            change.timestamp,
                                        )}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </>
        );
    }

    return (
        <div className="flex flex-col gap-4 text-sm">
            <div className="flex flex-col gap-1">
                <span className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                    Notas
                </span>
                <div className="text-gray-700 dark:text-gray-200">
                    {appt.notes ? (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: appt.notes,
                            }}
                        />
                    ) : (
                        <span className="text-gray-400 italic">Sin notas</span>
                    )}
                </div>
            </div>

            <div className="flex flex-wrap gap-3 items-center">
                <div className="flex items-center gap-2">
                    <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
                        Creado por:
                    </span>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                        {appt.createdBy || "Paciente"}
                    </span>
                </div>

                {appt.statusHistory?.length > 0 && (
                    <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
                            Cambios:
                        </span>
                        <div className="flex items-center gap-1.5 flex-wrap">
                            {appt.statusHistory.map((change, index) => (
                                <div
                                    key={`${appt.id || appt.time}-history-${index}`}
                                    className="flex items-center gap-1.5"
                                >
                                    {index === 0 && (
                                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300">
                                            {change.oldStatus}
                                        </span>
                                    )}
                                    <span className="text-gray-400">→</span>
                                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
                                        {change.newStatus}
                                    </span>
                                    <span className="text-xs text-gray-500 dark:text-gray-400">
                                        (por{" "}
                                        <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200">
                                            {change.changedBy}
                                        </span>
                                        ,{" "}
                                        {formatAppointmentHistoryDate(
                                            change.timestamp,
                                        )}
                                        )
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
